const CookieConsent = require("./CookieConsent");
const { ready } = require("./utils/dom");

ready(function () {
  if (window.madCC && window.madCC.config) {
    const cookieConsent = new CookieConsent(window.madCC.config);

    // Attach the instance to the global namespace for external access/debugging.
    window.madCC.instance = cookieConsent;
  }
});
